import { useMemo } from "react";
import { EMOJIS, type EmojiItem } from "./emoji-data";

export function useEmojiSearch(query: string): EmojiItem[] {
  return useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return EMOJIS;

    return EMOJIS.filter(
      (e) =>
        e.name.includes(q) ||
        e.keywords.some((k) => k.includes(q))
    );
  }, [query]);
}
